import { BoxZoomHandler } from 'mapbox-gl'
import React, { useContext, useEffect, useState } from 'react'
import { MapContext } from '../component'

export const ActivationButton = ({
  locales
}: {
  locales: { deactivate: string; activate: string }
}) => {
  const { deactivate, activate } = locales
  const map = useContext(MapContext)
  const [isActive, setIsActive] = useState<boolean>(false)
  const [showTooltip, setShowTooltip] = useState<boolean>(true)

  useEffect(() => {
    if (map) {
      if (!isActive) {
        map.resize()
        if (map.maincontainer && map.maincontainer.current)
          map.maincontainer.current.classList.remove('active')

        map.boxZoom.disable()
        map.scrollZoom.disable()
        map.dragRotate.disable()
        map.dragPan.disable()
        map.keyboard.disable()
        map.doubleClickZoom.disable()
        map.touchZoomRotate.disable()
        // map.active = false
      }
      if (isActive) {
        if (map.maincontainer && map.maincontainer.current) map.maincontainer.current.classList.add('active')
        map.boxZoom.enable()
        map.scrollZoom.enable()
        map.dragRotate.enable()
        map.dragPan.enable()
        map.keyboard.enable()
        map.doubleClickZoom.enable()
        map.touchZoomRotate.enable()
        // map.active = true
      }
    }
  }, [isActive])

  return (
    <>
      {showTooltip && (
        <span className='tooltip top activation'>
          Cliquez ici pour interagir avec la carte
        </span>
      )}
      <button
        className={'ActivationButton ' + (isActive ? 'scroll' : 'map')}
        onClick={() => {
          setShowTooltip(false)
          // if (isActive) {
          //   const search: HTMLDivElement = document.getElementsByClassName(
          //     'map-continue'
          //   )[0] as HTMLDivElement

          //   console.log(search)

          //   window.scrollTo({
          //     left: 0,
          //     top: search.getBoundingClientRect().top + window.scrollY,
          //     behavior: 'smooth'
          //   })
          // }
          setIsActive(!isActive)
        }}
      >
        {isActive ? deactivate : activate}
      </button>
    </>
  )
}
